<template>
  <b-button type="is-light" :disabled="loading || liveVehicles.length === 0" @click="exportCsv">
    <b-icon icon="file-export" size="is-small" />
    <span>Export CSV</span>
  </b-button>
</template>

<script>
import { formatCSV } from '@helpers/csv'
import { downloadFile } from '@helpers/downloadFile'
import {
  SPOT_TRACKER_TYPE,
  QUECLINK_TRACKER_TYPE,
  NEYOS_TRACKER_TYPE,
} from '@constants/tracker/type'

export default {
  name: 'LiveVehicleExportCsv.vue',

  props: {
    fileName: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    liveVehicles: {
      type: Array,
      required: true,
      validator: (v) =>
        v.every((obj) =>
          [
            'name',
            'number',
            'gender',
            'country',
            'accessType',
            'trackers',
            'categoryName',
            'comment',
            'phoneNumber',
          ].every((key) => key in obj),
        ),
    },
  },

  methods: {
    exportCsv() {
      const data = this.liveVehicles.map((vehicle, index) => [
        index + 1,
        vehicle.accessType,
        vehicle.trackers.find((tracker) => tracker.type === SPOT_TRACKER_TYPE)?.number,
        vehicle.trackers.find((tracker) => tracker.type === QUECLINK_TRACKER_TYPE)?.number,
        vehicle.trackers.find((tracker) => tracker.type === NEYOS_TRACKER_TYPE)?.number,
        vehicle.number,
        vehicle.name,
        vehicle.gender,
        vehicle.country,
        vehicle.categoryName,
        vehicle.phoneNumber,
        vehicle.comment,
      ])
      data.unshift([
        'Line',
        'Public/Private',
        'Spot',
        'Queclink',
        'Neyos',
        'Number',
        'Name',
        'Gender',
        'Country',
        'Category',
        'Phone',
        'Comment',
      ])

      downloadFile(formatCSV(data), 'csv', this.fileName)
    },
  },
}
</script>
